import api from "../../../../services/axios";

export const GetAllUsers = async () => {
  try {
    const res = await api.get("/Admin/UserManagement/GetAllUsers");
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const ActivateUser = async (userUID) => {
  try {
    const res = await api.post("/Admin/UserManagement/ActivateUser", { userUID });
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const DeactivateUser = async (userUID) => {
  try {
    const res = await api.post("/Admin/UserManagement/DeActivateUser", { userUID });
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
};

export const AssignManager = async (userUID, managerCode) => {
  try {
    const res = await api.post("/Admin/UserManagement/UpdateManagerAssignment", { userUID, managerCode });
    return res?.data;
  } catch (error) {
    throw error?.response?.data;
  }
}